import { Message } from '@stereograph/teia-system-design/components/Message';
import { usePluginTranslation } from '@translation';

export const TeiaQuantityTakeoffTableError = () => {
  const { t } = usePluginTranslation();

  return <Message color="error">{t('quantity_takeoff_plugin.table_error.label')}</Message>;
};
